import { getObjectContentsFromPath } from "@/app/helpers/stringpath.helper";
import DossierDetailComponent from "@/app/dynamic-components/details/detail-component-dossier.vue";
import { DetailComponentBase } from "@/app/dynamic-components/details/detail-component.base";
import {Store} from "vuex";
import Vue from "vue";
import {ruleEngine} from "@/app/services/rule.engine";
import {resolveEngine} from "@/app/helpers/resolve.engine";

export interface ContextAware {
  resolvePlaceholders(data: any): any;
  resolveFieldValue(dataPath: string): any;
  getData(): { [key: string]: any };
}

export class DetailContext implements ContextAware {
  public data: { [key: string]: any } = {};
  public definitionId = "";
  public root: DetailComponentBase | undefined = undefined;

  public setData(key: string, object: any) {
    if (key.startsWith("data.")) key = key.replace("data.", "");
    this.data[key] = object;
  }

  public resolvePlaceholders(data: any): any {
    return resolveEngine.resolvePlaceholders(data, this);
  }

  public resolveFieldValue(dataPath: string): any {
    return resolveEngine.resolveFieldValue(dataPath, this);
  }

  setRoot(root: DetailComponentBase, definitionId: string) {
    this.root = root;
    this.definitionId = definitionId;
  }

  Clone(): DetailContext {
    const d = new DetailContext();
    if (this.root) {
      d.setRoot(this.root, this.definitionId);
    }
    d.data = JSON.parse(JSON.stringify(this.data));
    return d;
  }

  getData(): { [p: string]: any } {
    return this.data;
  }
}
